module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would like to thank Sue Janet Clark for invaluable support and guidance throughout the production of this book and preceding books. Also, many thanks go to Dr. Thomas Storer, Darlene Dwyer, Marjorie Dwyer, and my friends at Pelican Publishing, Amy Kirk and John Scheyd, for their interest and encouraging messages when I needed them most. My thanks are also given to Patti Lierman of Fairhaven, Washington, for many fascinating ghost stories.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("“And when the last red man shall have perished from the earth and his memory among white men shall have become a myth, these shores shall swarm with the invisible dead of my tribe, and when your children’s children shall think themselves alone in the field, the store, the shop, upon the highway or in the silence of the woods they will not be alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Chief Seattle, 1854")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac0ff26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/06_9781589805170_Acknow.vue
// module id = 72
// module chunks = 0